import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import './assets/cloud-gateways.svg.mjs';
import './assets/internet-globe.svg.mjs';
import './assets/poe-plus-plus.svg.mjs';
import './assets/site-manager.svg.mjs';
import './assets/switching.svg.mjs';
import Internet__default from "../../../../assets/internet-globe.svg";
import SiteManager__default from "../../../../assets/site-manager.svg";
import CloudGatewaysIcon__default from "../../../../assets/cloud-gateways.svg";
import Switching__default from "../../../../assets/switching2.svg";
import PoePlusPlus__default from "../../../../assets/poe-plus-plus.svg";
"use strict";
const rootConfig = [{
  id: "internet",
  label: "commons.internet",
  icon: {
    src: Internet__default,
    width: 28,
    height: 28
  },
  lineHeight: 20
}, {
  id: "site-manager",
  label: "menu.label.siteManager",
  url: "https://unifi.ui.com/",
  isExternal: true,
  icon: {
    src: SiteManager__default,
    width: 78,
    height: 28
  },
  lineHeight: 37
}, {
  id: "cloud-gateways",
  label: "menu.label.cloudGateways",
  url: [SiteId.Ui, "/cloud-gateways"],
  icon: {
    src: CloudGatewaysIcon__default,
    width: 78,
    height: 28
  },
  isExternal: false,
  lineHeight: 21
}, {
  id: "site-manager",
  label: "menu.label.switching",
  url: [SiteId.Ui, "/switching"],
  icon: {
    src: Switching__default,
    width: 78,
    height: 28
  },
  isExternal: false,
  lineHeight: 20
}, {
  id: "poe-plus-plus",
  icon: {
    src: PoePlusPlus__default,
    width: 28,
    height: 28
  }
}];
export { rootConfig };
//# sourceMappingURL=Topology.config.mjs.map
